import loadId from 'src/internal/shared/loadId';

import type {ProjectName, ServiceName} from '@sail/observability';

export const REQUEST_SOURCE_HEADER = 'X-Request-Source';

export type RequestSourceInformation = {
  service: ServiceName | '<unknown>';
  project: ProjectName | '<unknown>';
  component: string;
  operation: string;
  is_prefetch?: boolean;
};

export function getRequestSourceInformation({
  service,
  project,
  component,
  operation,
}: {
  service?: ServiceName;
  project?: ProjectName;
  component?: string;
  operation?: string;
}): RequestSourceInformation {
  return {
    service: service ?? '<unknown>',
    project: project ?? '<unknown>',
    operation: operation ?? '<unknown>',
    component: component ?? '<unknown>',
  };
}

export function getRequestSourceHeader(info: RequestSourceInformation): string {
  const parts: string[] = [];

  for (const name in info) {
    if (info.hasOwnProperty(name)) {
      const value = info[name as keyof RequestSourceInformation];
      const cleanValue =
        typeof value === 'string' ? value.replace(/[^\x20-\x7E]/g, '?') : value;

      parts.push(`${name}=${JSON.stringify(cleanValue)}`);
    }
  }

  return parts.concat(`load_id="${loadId}"`).join('; ');
}
